var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{attrs:{"dir":"ltr"}},[_vm._v("404 Not Found Admin !")])
}
var staticRenderFns = []

export { render, staticRenderFns }